import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const moveRightToLeft = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const moveLeftToRight = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const Ticker = ({
  messages = "sample",
  direction = "left",
  speed = 5,
  position = "top",
  tickerTextColor,
  tickerBgColor,
  checkIfTrue,
  inline = false,
  viewportEdge = false,
}) => {
  const [directionTicker, setDirectionTicker] = useState(
    direction === "center" ? "LTR" : "",
  ); // Start Left to Right

  // Tickers alternative

  useEffect(() => {
    const interval = setInterval(() => {
      setDirectionTicker((prev) => (prev === "LTR" ? "RTL" : "LTR"));
    }, speed * 1000);

    return () => clearInterval(interval);
  }, [speed]);

  return position === "top" ? (
    <TopTickerContainer
      inline={inline}
      style={{
        borderRadius: "0px 0px 0px 0px",
        backgroundColor: tickerBgColor,
      }}
    >
      {direction === "center" ? (
        <AlternateTickerText
          direction={directionTicker}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </AlternateTickerText>
      ) : (
        <TickerText
          direction={direction}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </TickerText>
      )}
    </TopTickerContainer>
  ) : position === "bottom" ? (
    <BottomTickerContainer
      inline={inline}
      viewportEdge={viewportEdge}
      {...{ checkIfTrue }}
      style={{
        borderRadius: viewportEdge ? "0 0 0 0" : "0 0 0 0",
        backgroundColor: tickerBgColor,
      }}
    >
      {direction === "center" ? (
        <AlternateTickerText
          direction={directionTicker}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </AlternateTickerText>
      ) : (
        <TickerText
          direction={direction}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </TickerText>
      )}
    </BottomTickerContainer>
  ) : (
    <CenterTickerContainer
      inline={inline}
      style={{
        backgroundColor: tickerBgColor,
      }}
    >
      {direction === "center" ? (
        <AlternateTickerText
          direction={directionTicker}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </AlternateTickerText>
      ) : (
        <TickerText
          direction={direction}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </TickerText>
      )}
    </CenterTickerContainer>
  );
};

export default Ticker;

const BottomTickerContainer = styled.div`
  position: ${({ viewportEdge, inline }) =>
    viewportEdge ? "fixed" : inline ? "relative" : "fixed"};
  left: ${({ viewportEdge }) => (viewportEdge ? "50%" : "0")};
  bottom: ${({ viewportEdge, inline, checkIfTrue }) =>
    viewportEdge ? "0" : inline ? "0" : checkIfTrue ? "6%" : "1%"};
  width: ${({ viewportEdge }) =>
    viewportEdge ? "calc(100% - clamp(24px, 4vw, 56px))" : "100%"};
  // max-width: ${({ viewportEdge }) => (viewportEdge ? "1440px" : "none")};
  margin-top: ${({ inline, viewportEdge }) =>
    inline && !viewportEdge ? "10px" : "0"};
  transform: ${({ viewportEdge }) =>
    viewportEdge ? "translateX(-50%)" : "none"};

  background: #ff5733;
  padding: 10px 12px;
  box-sizing: border-box;
  opacity: 0.8;
  overflow: hidden;
  pointer-events: none;
  z-index: 90;

  @media only screen and (max-width: 767px) {
    width: ${({ viewportEdge }) =>
      viewportEdge ? "calc(100% - 24px)" : "100%"};
    bottom: ${({ viewportEdge, inline, checkIfTrue }) =>
      viewportEdge ? "0" : inline ? "0" : checkIfTrue ? "6%" : "11.5%"};
  }
`;

export const TopTickerContainer = styled.div`
  position: ${({ inline }) => (inline ? "relative" : "fixed")};
  top: ${({ inline }) => (inline ? "0" : "23%")};
  left: 0;
  width: 100%;
  // max-width: ${({ inline }) => (inline ? "1440px" : "none")};
  flex: 0 0 auto;
  margin-bottom: ${({ inline }) =>
    inline ? "clamp(12px, 2vh, 20px)" : "0"};
  background: #ff5733;
  padding: 8px 12px;
  box-sizing: border-box;
  opacity: 0.8;
  text-align: center;
  overflow: hidden;
  pointer-events: none;
  z-index: 999;
`;

const CenterTickerContainer = styled.div`
  position: ${({ inline }) => (inline ? "relative" : "fixed")};
  top: ${({ inline }) => (inline ? "auto" : "50%")};
  left: 0;
  transform: ${({ inline }) => (inline ? "none" : "translateY(-50%)")};
  width: 100%;
  max-width: ${({ inline }) => (inline ? "1440px" : "none")};
  background: #ff5733;
  color: white;
  opacity: 0.8;
  margin: ${({ inline }) => (inline ? "clamp(12px, 2vh, 20px) 0" : "0")};
  padding: 10px 12px;
  box-sizing: border-box;
  z-index: 999;
  overflow: hidden;
  pointer-events: none;
`;

const TickerText = styled.div`
  display: inline-block;
  white-space: nowrap;
  font-size: clamp(14px, 1.5vw, 22px);
  font-weight: bold;
  font-family: "Poppins", sans-serif;
  width: 100%;
  animation: ${(props) =>
      props.direction === "left" ? moveLeftToRight : moveRightToLeft}
    ${(props) => props.speed}s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    text-align: center;
  }
`;

const AlternateTickerText = styled.div`
  display: inline-block;
  white-space: nowrap;
  font-size: clamp(14px, 1.5vw, 22px);
  font-weight: bold;
  font-family: "Poppins", sans-serif;
  width: 100%;
  animation: ${(props) =>
      props.direction === "LTR" ? moveLeftToRight : moveRightToLeft}
    ${(props) => props.speed}s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    text-align: center;
  }
`;
